import { PermissionsTemplateType } from '@wix/ambassador-cloud-autocms-v3-collection-metadata/types'
import { getCollectionMetadata } from '@wix/ambassador-cloud-autocms-v3-collection-metadata/http'
import type { HttpClient } from '@wix/http-client'

export const getPermissionsTemplate = async (
  httpClient: HttpClient,
  dataCollectionId: string,
) => {
  try {
    const {
      data: { collectionMetadata },
    } = await httpClient.request(getCollectionMetadata({ dataCollectionId }))

    return collectionMetadata?.permissionsTemplate
  } catch {
    return PermissionsTemplateType.SHOW_CONTENT
  }
}
